import {
  HeroContainer,
  HeroContainerRight,
  HeroText,
  HeroSocial,
  SocialButtonTwitter,
  SocialButtonLinkedin,
  SocialButtonInstagram,
  SocialButtonGithub,
  SocialButtonFacebook,
} from './styled';
// import { HeroCarousel } from './HeroCarousel';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
export function Hero() {
  return (
    <HeroContainer height={480}>
      <HeroContainerRight>
        <HeroText>
          <h2 style={{ marginBottom: 0, fontSize: '40px' }}>
            Hi 👋🏾, I'm
            <span style={{ marginBottom: 0, fontSize: '40px', fontWeight: 800 }}> Jamal</span>
          </h2>
          <em style={{ marginBottom: 0, fontSize: '20px' }}>
            I am a technologist with a range of skills.
          </em>
        </HeroText>
        <HeroSocial>
          <SocialButtonTwitter>
            <a style={{ color: 'white' }} rel="noreferrer" href="https://twitter.com/jm4l1">
              <TwitterIcon />
            </a>
          </SocialButtonTwitter>
          <SocialButtonLinkedin>
            <a
              style={{ color: 'white' }}
              rel="noreferrer"
              href="https://www.linkedin.com/in/jamalmoore/"
            >
              <LinkedIcon />
            </a>
          </SocialButtonLinkedin>
          <SocialButtonInstagram>
            <a style={{ color: 'white' }} rel="noreferrer" href="https://www.instagram.com/jm4l1/">
              <InstagramIcon />
            </a>
          </SocialButtonInstagram>
          <SocialButtonGithub>
            <a style={{ color: 'white' }} rel="noreferrer" href="https://github.com/jm4l1">
              <GitHubIcon />
            </a>
          </SocialButtonGithub>
          <SocialButtonFacebook>
            <a
              style={{ color: 'white' }}
              rel="noreferrer"
              href="https://www.facebook.com/jamal.moore.5855"
            >
              <FacebookIcon />
            </a>
          </SocialButtonFacebook>
        </HeroSocial>
      </HeroContainerRight>
    </HeroContainer>
  );
}
